<template>
  <div class="player-time">
    <!--p class="player-time__num player-time__num--pos">
      {{ progressControl.position }}
    </p-->
    <p ref="positionLabel" class="player-time__num player-time__num--pos"></p>

    <vue-slider
      ref="slider"
      :modelValue="progressControl.positionInPercent || 0"
      :min="0"
      class="player__audioplayer"
      :dragOnClick="true"
      :interval="1"
      tooltip="none"
      @change="inputChange"
      @dragStart="dragStart"
      @dragEnd="dragEnd"
    />
    <!--p class="player-time__num player-time__num--duration">
      {{ progressControl.duration }}
    </p-->
    <p
      ref="durationLabel"
      class="player-time__num player-time__num--duration"
    ></p>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import {
  ChapterProgressControl,
  ChapterPrevNextControl,
} from '@/services/player'
import VueSlider from 'vue-slider-component'

const props = defineProps<{
  progressControl: ChapterProgressControl
  chapterControl: ChapterPrevNextControl
}>()

const slider = ref<InstanceType<typeof VueSlider> | null>(null)
const positionLabel = ref<HTMLElement | null>(null)
const durationLabel = ref<HTMLElement | null>(null)

const currentPosition = ref('')
const currentDuration = ref('')

onMounted(() => {
  props.progressControl._updateCallback = updateTimings
  // Update timings initially, while audio is loading.
  updateTimings()
})

function inputChange(percent: number): void {
  if (props.progressControl.positionInPercent !== percent && !isNaN(percent)) {
    props.progressControl.inputChange(percent)
  }
}

function dragStart(): void {
  props.chapterControl.dragStart()
}

function dragEnd(): void {
  props.chapterControl.dragEnd()
}

function updateTimings(): void {
  // When we use regular Vue approach to render position and duration,
  // the value sometimes rendered multiple times.
  // For example, in Chrome, mobile width, if we click forward (+15sec)
  // button 3 times quickly and then start the playback, the position
  // value will be duplicated.
  // Similarly, when the audio is playing, if we select the position text
  // with mouse, it will be duplicated.
  // I think this is Vue bug, especially since it is reproduced just with
  // text selection - we do not do anything here.
  // I was also able to reproduce it with simple counter increasing in
  // `setInterval` handler.
  // On the other hand, it might be a combination of data setup and HTML
  // structure and can be caused by something in our code.
  //
  // As a last resort solution, I update timings manually here.
  // See #2150.
  //
  // We also save current position and duration into component fields
  // for tests, as they are invisible in HTML.
  currentPosition.value = props.progressControl.position
  currentDuration.value = props.progressControl.duration

  if (positionLabel.value && durationLabel.value) {
    positionLabel.value.innerText = currentPosition.value
    durationLabel.value.innerText = currentDuration.value
  }

  if (slider.value && !isNaN(props.progressControl.positionInPercent)) {
    slider.value.setValue(props.progressControl.positionInPercent)
  }
}

defineExpose({
  currentPosition,
  currentDuration,
})
</script>
